import { render } from "./SignatureForm.vue?vue&type=template&id=3cbe4e9a"
import script from "./SignatureForm.vue?vue&type=script&lang=js"
export * from "./SignatureForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__